export const createDefaultObjectByType = (type, pageId, nextZIndex = 0) => {
    const base = {
        page: pageId,
        type,
        x: 120,
        y: 120,
        width: 180,
        height: 60,
        rotation: 0,
        z_index: nextZIndex,
        opacity: 1,
        visible: true,
        locked: false,
        style_json: {},
        data_json: {},
        meta_json: {},
    };

    switch (type) {
        case "text":
            return {
                ...base,
                name: `text-${Date.now()}`,
                width: 220,
                height: 56,
                style_json: {
                    fontSize: 24,
                    fontWeight: "bold",
                    color: "#111827",
                },
                data_json: {
                    text: "New Text",
                },
            };

        case "shape":
            return {
                ...base,
                name: `shape-${Date.now()}`,
                width: 220,
                height: 120,
                style_json: {
                    backgroundColor: "#93c5fd",
                    borderColor: "#2563eb",
                    borderWidth: 2,
                    borderRadius: 8,
                    lineColor: "#2563eb",
                    lineThickness: 2,
                },
                data_json: {
                    shape_type: "rectangle",   // rectangle | square | circle | ellipse | triangle | line | polygon | custom
                    polygon_sides: 6,
                    render_mode: "filled",     // filled | outline
                    transparent_fill: false,

                    // برای custom
                    custom_points: "10,10 90,10 70,50 90,90 10,90",
                    custom_closed: true,
                },
            };

        case "tag":
            return {
                ...base,
                name: `tag-${Date.now()}`,
                width: 240,
                height: 48,
                style_json: {
                    fontSize: 18,
                    color: "#1d4ed8",

                    // 👇 جدید
                    hasBackground: false,
                    backgroundColor: "#e0f2fe",
                    borderRadius: 8,
                    padding: 6,
                },
                data_json: {
                    prefix: "Tag: ",
                    value: "0",
                    unit: "",
                    tag_name: "",
                    tag_mode: "manual",
                    object_mode: "monitor",
                    control_type: "digital",
                },
            };

        case "button":
            return {
                ...base,
                name: `button-${Date.now()}`,
                width: 150,
                height: 50,
                style_json: {
                    fontSize: 16,
                    fontWeight: "bold",
                    backgroundColor: "#16a34a",
                    color: "#ffffff",
                    borderRadius: 10,
                },
                data_json: {
                    label: "Button",
                    action_type: "tag_write",
                    tag_name: "",
                    write_value: 1,
                    url: "",
                    open_in_new_tab: true,
                    tag_type: "digital",
                },
            };

        case "image":
            return {
                ...base,
                name: `image-${Date.now()}`,
                width: 180,
                height: 180,
                style_json: {
                    borderRadius: 8,
                    backgroundColor: "#f8fafc",
                },
                data_json: {
                    src: "",
                    objectFit: "contain",
                },
            };

        default:
            return {
                ...base,
                name: `object-${Date.now()}`,
            };
    }
};